import { ListUser } from "models/list-user";
import { doPatch } from "../request";

// allow user to change personal status to "submitted"
export const userDoPostUserStatusSubmitted = async () => {
  const user = await doPatch<ListUser>(`/user/status/submitted`);
  return user;
};

// allow user to change personal status to "progress"
export const userDoPostUserStatusProgress = async () => {
  const user = await doPatch<ListUser>(`/user/status/progress`);
  return user;
};
